<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }},
        hecho por
        <a href="#" target="_self">Iliux, S.A</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
